import { FormControlLabel, Switch } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { SwitchFormFieldProps } from '@zealth/core/formFields/types'

export const SwitchFormField = ({ label }: SwitchFormFieldProps) => {
  const field = useFieldContext<boolean>()

  return (
    <FormControlLabel
      label={label}
      labelPlacement="start"
      control={
        <Switch
          checked={field.state.value}
          onChange={e => field.handleChange(e.target.checked)}
        />
      }
      slotProps={{
        typography: { variant: 'cta2' },
      }}
      sx={{
        justifyContent: 'space-between',
      }}
    />
  )
}
